import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import {GaTrackingEventName, GATrackingEventType} from '../../constants';


export class GaTrackingNotificationEvent implements GATrackingEvent {

  constructor(
    private section: string,
    private title: string
  ) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.Notification;
  }

  getPayload(): GATrackingEventPayload {
    const category = GaTrackingEventName.Notifications;
    return {
      event: category,
      category,
      label: `${this.title}`,
      gtmCustom: {
        category,
        action: this.section
      }
    };
  }
}
